import React from 'react'
import { AppFC } from 'types'

const SectionTitle: AppFC = ({ children }) => {
  return <h3 className="text-[36px] font-light">{children}</h3>
}

export default SectionTitle
